import Alert from '@mui/material/Alert';
import MaterialLink from '../material-link';
import { momentParse } from '../../utils/time';
import { eventPath, eventSeriesPath } from '../../utils/slugify';
import type { Event } from '../../types/Event';

type Series = {
  id: string;
  name: string;
};

type Props = {
  series: Series;
  upcomingEvents?: Event[];
};

const EventSeriesUpcoming = ({ series, upcomingEvents }: Props) => {
  const nextEvent = upcomingEvents?.[0];

  return (
    <Alert severity="info" sx={{ mb: 2 }}>
      Part of{' '}
      <MaterialLink href={eventSeriesPath(series.id, series.name)} sx={{ fontWeight: 'bold' }}>
        {series.name}
      </MaterialLink>
      {' '}series.
      {nextEvent && (
        <>
          {' '}Next up:{' '}
          <MaterialLink href={eventPath(nextEvent.id, nextEvent.name)} sx={{ fontWeight: 'bold' }}>
            {nextEvent.name}
          </MaterialLink>
          {' '}on {momentParse(nextEvent.startAt, nextEvent.timezone).format('ddd, MMM D [at] h:mm a')}.
        </>
      )}
      {' '}<MaterialLink href={eventSeriesPath(series.id, series.name)}>View all →</MaterialLink>
    </Alert>
  );
};

export default EventSeriesUpcoming;
